document.addEventListener( 'DOMContentLoaded', function () {
	const gallery = document.querySelector( '[data-media-album-gallery]' );

	if ( ! gallery ) {
		return;
	}

	const figure = gallery.querySelector( '.wp-block-gallery' );
	const loader = gallery.querySelector( '[data-media-album-gallery-loader]' );
	const sentinel = gallery.querySelector( '[data-media-album-gallery-sentinel]' );

	const config = {
		ajaxUrl: gallery.dataset.ajaxUrl,
		nonce: gallery.dataset.nonce,
		postId: gallery.dataset.postId,
	};

	let offset = parseInt( gallery.dataset.offset, 10 ) || 9;
	let hasMore = gallery.dataset.hasMore === '1';
	let isLoading = false;
	let fancyboxItems = [];

	try {
		fancyboxItems = JSON.parse( gallery.dataset.fancyboxItems || '[]' );
	} catch ( error ) {
		console.error( 'media-gallery: invalid fancybox items', error );
	}

	if ( figure && fancyboxItems.length && typeof Fancybox !== 'undefined' ) {
		figure.addEventListener( 'click', function ( event ) {
			const link = event.target.closest( 'a[data-gallery-index]' );

			if ( ! link || ! figure.contains( link ) ) {
				return;
			}

			event.preventDefault();

			const index = parseInt( link.dataset.galleryIndex, 10 ) || 0;

			Fancybox.show( fancyboxItems, {
				startIndex: index,
			} );
		} );
	}

	if ( ! hasMore || ! sentinel || ! config.ajaxUrl || ! config.postId ) {
		return;
	}

	async function loadMore() {
		if ( isLoading || ! hasMore ) {
			return;
		}

		isLoading = true;
		gallery.classList.add( 'is-loading' );

		try {
			const body = new FormData();

			body.append( 'action', 'fd_get_media_album_gallery' );
			body.append( 'nonce', config.nonce );
			body.append( 'post_id', config.postId );
			body.append( 'offset', String( offset ) );

			const response = await fetch( config.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			} );

			const data = await response.json();

			if ( ! data.success ) {
				return;
			}

			if ( data.data.html && figure ) {
				const temp = document.createElement( 'div' );
				temp.innerHTML = data.data.html;

				temp.querySelectorAll( '.wp-block-image' ).forEach( function ( item ) {
					figure.appendChild( item );
				} );
			}

			hasMore = Boolean( data.data.has_more );
			offset = data.data.next_offset ?? offset;
			gallery.dataset.hasMore = hasMore ? '1' : '0';
			gallery.dataset.offset = String( offset );

			if ( ! hasMore ) {
				loader?.remove();
				sentinel.remove();
				observer.disconnect();
			}
		} catch ( error ) {
			console.error( 'media-gallery:', error );
		} finally {
			isLoading = false;
			gallery.classList.remove( 'is-loading' );
		}
	}

	const observer = new IntersectionObserver(
		function ( entries ) {
			if ( entries.some( function ( entry ) {
				return entry.isIntersecting;
			} ) ) {
				loadMore();
			}
		},
		{
			rootMargin: '200px 0px',
		}
	);

	observer.observe( sentinel );
} );
